import React, { CSSProperties } from 'react';
import styled from 'styled-components';

import { Typography } from 'common/typography';

import { Breakpoints } from '../../../constants/breakpoints';
import { ListRowCategoryProps } from '../types';

const Root = styled(Typography.Heading6)`
  padding: 6px 32px;

  @media (max-width: ${Breakpoints.MOBILE}px) {
    padding: 2px 8px;
  }
`;

export const ListRowCategory = ({ name, style }: ListRowCategoryProps & { style: CSSProperties }) => {
  return <Root style={style}>{name}</Root>;
};
